import React from "react";
import styled from "styled-components";

interface SVerticalTableContainer {
  tableMinWidth?: number;
}

interface VerticalTableProps extends SVerticalTableContainer {
  tableHeaderData?: (string | null)[];
  tableBodyData?: (string | undefined)[];
  tableFlexBodyData?: any;
}

export default function VerticalTable({
  tableHeaderData,
  tableBodyData,
  tableFlexBodyData,
  tableMinWidth,
}: VerticalTableProps) {
  const filteredTableHeaderData = tableHeaderData?.filter((e) => e !== null);

  const filteredTableFlexBodyData = tableFlexBodyData?.filter(
    (e: string | any[]) => e?.length > 0
  );

  return (
    <VerticalTableContainer tableMinWidth={tableMinWidth}>
      <VerticalTableColumn>
        {filteredTableHeaderData?.map((h, index) => (
          <TableHeader key={index}>{h}</TableHeader>
        ))}
      </VerticalTableColumn>

      <VerticalTableColumn>
        {tableBodyData &&
          tableBodyData?.map((b, index) => {
            return (
              <TableValueContainer key={index}>
                <TableValue>{b}</TableValue>
              </TableValueContainer>
            );
          })}

        {filteredTableFlexBodyData &&
          filteredTableFlexBodyData?.map((b: any, index: any) => {
            return (
              <TableValueContainer key={index}>
                {<TableValue>{b[0] ?? ""}</TableValue>}
                {<TableValue>{b[1] ?? ""}</TableValue>}
              </TableValueContainer>
            );
          })}
      </VerticalTableColumn>
    </VerticalTableContainer>
  );
}

const VerticalTableContainer = styled.div<SVerticalTableContainer>`
  min-width: ${({ tableMinWidth }) => tableMinWidth ?? 400}px;
  width: 100%;
  border-top: 2px solid ${({ theme }) => theme.buttonColor.lineNormal};
  border-bottom: 2px solid ${({ theme }) => theme.buttonColor.lineNormal};
  display: flex;
`;

const VerticalTableColumn = styled.div`
  &:first-child {
    min-width: 110px;
  }

  &:last-child {
    width: 100%;
  }
`;

const TableHeader = styled.div`
  padding-left: 12px;
  display: flex;
  height: 48px;
  align-items: center;

  font-size: 14px;
  font-weight: bold;
  line-height: 22.5px;
  text-align: left;
  color: #858c97;
`;

const TableValue = styled(TableHeader)`
  padding-left: 20px;

  font-size: 15px;
  font-weight: 500;
  color: #2f2f38;
`;

const TableValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
